import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import gsap from "gsap";

export class News {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     * @deprecated (blog layout curretly used for both the blog and news page)
     */
    dom = {
        container: undefined
    };

    state = {
        open: false
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init());
    }

    openAccordion(e) {
        if (e.target.classList.contains("news__subheading")) {
            const tl = gsap.timeline();
            const parent = e.target.parentNode.parentNode;
            const folder = parent.querySelector(".news__months-folder");
            const h5 = parent.querySelector(".news__months--container");
            tl.from(folder, { height: 0, duration: 0.5, ease: "power2.out" });
            tl.from(
                h5,
                { opacity: 0, duration: 0.3, ease: "power2.out" },
                "-=.45"
            );
            const ariaValue = JSON.parse(parent.getAttribute("aria-expanded"));
            parent.setAttribute("aria-expanded", !ariaValue);
        }
    }

    openAccordionChild(e) {
        if (e.target.classList.contains("news__month")) {
            const tl = gsap.timeline();
            const parent = e.target.parentNode.parentNode;
            const newSummary = parent.querySelectorAll(".new__summary");
            const ariaValue = JSON.parse(parent.getAttribute("aria-expanded"));
            newSummary.forEach(article => {
                if (!ariaValue) {
                    tl.to(article, {
                        height: "auto",
                        duration: 0.3,
                        ease: "power2.out"
                    });
                    tl.to(article, {
                        opacity: 1,
                        duration: 0.25,
                        ease: "power2.out"
                    });
                } else {
                    tl.to(article, {
                        opacity: 0,
                        duration: 0.25,
                        ease: "power2.out"
                    });
                    tl.to(article, {
                        height: 0,
                        duration: 0.3,
                        ease: "power2.out"
                    });
                }
            });
            parent.setAttribute("aria-expanded", !ariaValue);
        }
    }

    init() {
        console.log("init");

        const yearFolder =
            this.dom.container.querySelectorAll(".news__year-folder");
        yearFolder.forEach(folder => {
            addEvent(folder, "click", e => this.openAccordion(e));
        });
        const monthFolder = this.dom.container.querySelectorAll(
            ".news__months-folder"
        );
        monthFolder.forEach(folder => {
            addEvent(folder, "click", e => this.openAccordionChild(e));
        });
    }
}
